module.exports = __webpack_public_path__ + "media/images/preview_close_icon-bcb5c2ce21f3a700105af52ae7cba60f.svg";